module.exports = __webpack_public_path__ + "static/media/right.0c3859a3.svg";